import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getBuyerReqItems = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-req-item/`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerReqItems - error", error)
        return handleApiError(error)
    }
}

export const getBuyerReqItemDataById = async (buyerReqItemId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-req-item/${buyerReqItemId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerReqItemById - error", error)
        return handleApiError(error)
    }
}

export const addBuyerReqItemData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-req-item/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addBuyerReqItem - error", error)
        return handleApiError(error)
    }
}

export const getMaterialItemsDataByBuyerReqItemIds = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-req-item/materialData`, data)
        return await response.data
    } catch (error) {
        console.log("getMaterialItemsDataByBuyerReqItemIds - error", error)
        return handleApiError(error)
    }
}

export const getMaterialItemsDataByBuyerReqItemIdsNew = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-req-item/materialDataNew`, data)
        return await response.data
    } catch (error) {
        console.log("getMaterialItemsDataByBuyerReqItemIdsNew - error", error)
        return handleApiError(error)
    }
}

export const updateBuyerReqItemQty = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-req-item/update-qty`, data)
        return await response.data
    } catch (error) {
        console.log("updateBuyerReqItem - error", error)
        return handleApiError(error)
    }
}